module.exports = __webpack_public_path__ + "img/Notifications-bell.e2c71e4e.png";